<template>
	<div class="text-center">
		<v-progress-circular v-if="isLoading"></v-progress-circular>
		<v-dialog
			v-else
			v-model="show"
			width="600"
			@input="(v) => v || closeModal()"
			content-class="create-thread-modal overflow-x-hidden"
			@click:outside="closeModal"
		>
			<v-card :class="['create-thread-modal__card', { 'scroll-active': hasScroll }]">
				<v-icon
					class="create-thread-modal__card__closes"
					style="cursor: pointer"
					@click="closeModal"
				>
					mdi-close
				</v-icon>
				<div class="create__title d-flex justify-space-between mb-5">
					{{ edit ? 'Edit' : 'Create' }} Post
				</div>
				<PostTextForm
					v-on:closeModal="closeModal"
					@postCreated="onPostCreated"
					:activeTab="tab"
					:edit="edit"
					:post="post"
					:chaptersList="chaptersList"
				/>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PostTextForm from '@/components/Forms/PostTextForm'

export default {
	components: { PostTextForm },

	props: {
		show: {
			type: Boolean,
			default: false,
		},
		edit: {
			type: Boolean,
			default: false,
		},
		post: {
			type: Object,
			default: () => ({}),
		},
	},

	data: () => ({
		tab: null,
		hasScroll: false,
	}),

	methods: {
		...mapActions('chats', ['deleteMessage']),
		...mapActions('settings', ['fetchChapters', 'getAppCoreSettings']),
		onPostCreated() {
			this.$emit('postCreated')
			this.closeModal()
		},

		closeModal() {
			this.$emit('closeModal')
		},
	},

	computed: {
		...mapGetters('settings', ['chaptersList', 'isLoading']),
		...mapGetters('post', ['isFileLoading', 'postFile']),
		...mapGetters('tag', ['tags']),
	},
	mounted() {
		this.$nextTick(() => {
			const el = this.$el.querySelector('.create-thread-modal__scroll-wrapper')
			if (el && el.scrollHeight > el.clientHeight) {
				this.hasScroll = true
			}
		})
	},

	async created() {
		if (!this.edit) {
			await this.fetchChapters({
				thread_type: 1,
				thread_category_id: this.$route.query.category_id,
				thread_menu_id: this.$route.query.thread_menu_id,
			})
		}
		if (this.edit && this.post) {
			this.tab = this.post.thread_type === 3 ? 1 : 0
		}
	},
}
</script>

<style lang="scss">
.create-thread-modal__tabs-wrapper_v-tabs {
	margin-left: -15px;
	margin-top: 20px;
	color: #9b9b9b;
	font-weight: 700;
	width: 30px;
	height: 17px;
}
.create-thread-modal__card__closes {
	position: absolute !important;
	cursor: pointer;
	top: 8px;
	right: 8px;
}
.create__title {
	font-family: 'Inter', sans-serif !important;
	font-size: 24px;
	line-height: 29.05px;
	font-weight: 700;
	color: #4a4a4a;
}
.create-thread-modal {
	font-family: 'Inter', sans-serif !important;
	border-radius: 8px !important;
	max-height: 650px !important;

	&__card {
		padding: 24px 4px 24px 24px !important;
		background-color: #ffffff;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		position: relative !important;
		&.scroll-active {
			padding-right: 4px;
		}
	}

	&__title {
		font-family: 'Inter', sans-serif !important;
		font-size: 24px;
		line-height: 29.05px;
		font-weight: 700;
		color: #4a4a4a;
	}
	&__scroll-wrapper {
		overflow-y: auto;
		max-height: 500px;
		padding-right: 20px;

		&::-webkit-scrollbar {
			width: 6px;
		}
		&::-webkit-scrollbar-thumb {
			background-color: #ccc;
			border-radius: 8px;
			transition: background-color 0.3s;
		}
		&::-webkit-scrollbar-thumb:hover {
			background-color: #aaa;
		}
		&::-webkit-scrollbar-track {
			background-color: transparent;
		}
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 12px;
		font-family: Inter, sans-serif;
		font-weight: 600;
		letter-spacing: -0.29px;
		padding: 10px 0;
	}

	&__tabs-wrapper {
		padding-bottom: 10px;

		.v-slide-group__wrapper {
			border-bottom: 1px solid rgb(219, 219, 219);
		}

		.v-tabs-slider {
			width: 60px;
		}
	}
}
</style>
